import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/flow`;

export const fetchFlow = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/account/${uuid}`, getAuthHeaders());
  return res.data;
};

export const updateFlow = async (uuid, data) => {
  const res = await axiosInstance.put(`${BASE_URL}/${uuid}`, data, getAuthHeaders());
  return res.data;
};

export const updatenodeFlow = async (uuid, data) => {
  const res = await axiosInstance.put(`${BASE_URL}/node/${uuid}`, data, getAuthHeaders());
  return res.data;
};

export const fetchAllFlow = async () => {
  const res = await axiosInstance.get(BASE_URL, getAuthHeaders());
  return res.data;
};

export const createFlow = async (data) => {
  const res = await axiosInstance.post(`${BASE_URL}/save-flow`, data, getAuthHeaders());
  return res.data;
};

export const deleteFlow = async (uuid) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};